import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.41602 8.91666H6.58268V5.41666H5.41602V8.91666ZM5.99935 0.166656C2.77935 0.166656 0.166016 2.77999 0.166016 5.99999C0.166016 9.21999 2.77935 11.8333 5.99935 11.8333C9.21935 11.8333 11.8327 9.21999 11.8327 5.99999C11.8327 2.77999 9.21935 0.166656 5.99935 0.166656ZM5.99935 10.6667C3.42685 10.6667 1.33268 8.57249 1.33268 5.99999C1.33268 3.42749 3.42685 1.33332 5.99935 1.33332C8.57185 1.33332 10.666 3.42749 10.666 5.99999C10.666 8.57249 8.57185 10.6667 5.99935 10.6667ZM5.41602 4.24999H6.58268V3.08332H5.41602V4.24999Z",
  fill: "#797979",
  "fill-opacity": "0.8"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}